import angular from 'angular';
import messageShowModal from './../history/messageShow.modal.html';
import messageDeleteModal from './deleteConfirm.modal.html';

class activePromoMessageController {
  /* @ngInject */
  constructor(MessageOutboundService, $timeout, ModalFactory, NewTokenService) {
    let messages = [];
    let modal = undefined;

    this.loader = false;
    this.listing_mode = 'active_promo';

    this.pagination = {
      currentPage: {
        number: 0,
        data: []
      },
      pageSize: 20
    };

    this.changePage = (page = 0) => {
      if (messages === undefined) return;
      if (angular.isArray(messages) && messages.length === 0) return;
      this.pagination.currentPage.number = page;
      const pageStart = page * this.pagination.pageSize;
      const pageEnd = pageStart + this.pagination.pageSize;
      this.pagination.currentPage.data = messages.slice(pageStart, pageEnd);
    };
    const loadMerchantProfile = () => {
      this.userContext = NewTokenService.getUserContext();
    };

    const closeModal = () => {
      modal.deactivate();
      $timeout(modal.destroy, 10);
    };

    this.deleteMessage = ( message ) => {
      MessageOutboundService.deleteMessage(this.userContext, message.id).then((response) => {
        console.log( response );
        messages = response.response;
        this.pagination.elementsCount = messages.length;
        this.changePage();
        FoundationApi.publish('notifications', {
          color: 'success',
          title: $translate.instant('common.info'),
          content: "Il messaggio è stato eliminato correttamente", // FIXME translate
          autoclose: 3000
        });
      }, reason => {
        FoundationApi.publish('notifications', {
          color: 'alert',
          title: $translate.instant('common.error'),
          //content: UiService.parseErrorMessage(data.message),
          autoclose: 3000
        });
      }).finally(() => {
        this.loader = false;
        init();
        closeModal();
      });

    };

    this.openDeleteModal = ( message ) => {
      modal = new ModalFactory({
        overlay: true,
        overlayClose: false,
        template: messageDeleteModal,
        class: '',
        contentScope: {
          message: message,
          delete: this.deleteMessage,
          cancel: closeModal
        }
      });

      modal.activate();
    }


    this.openMessageShowModal = ( message ) => {
      message.content_type = message.content_type || "not_set";
      modal = new ModalFactory({
        overlay: true,
        overlayClose: false,
        template: messageShowModal,
        class: 'large',
        contentScope: {
          message: message,
          cancel: closeModal
        }
      });

      modal.activate();
    };


    const init = () => {
      loadMerchantProfile();
      this.loader = true;
      MessageOutboundService.getMessagesListing(this.userContext, this.listing_mode).then((response) => {
        console.log( response );
        messages = response.response;
        this.pagination.elementsCount = messages.length;
        this.changePage();
      }).finally(() => {
        this.loader = false;
      });
    };

    this.$onInit = init;
  }
}

export default activePromoMessageController;



/** WEBPACK FOOTER **
 ** ./client/app/components/messageOutbound/active_promo/active_promo.controller.js
 **/